import BaseModel from '../../BaseModel';

export default class MailTemplateEditor extends BaseModel {
  static entity = 'mailTemplateEditor';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      company_id: this.attr(null),
      template: this.attr(null),
      redacting: this.attr(null),
      isPublished: this.boolean(false),
    };
  }

  static apiConfig = {
    actions: {
      async fetchMailTemplate() {
        return this.get('companies/mail-template');
      },
      async updateMailTemplate(payload) {
        return this.post('companies/mail-template', payload);
      },
      async applyRedactingMailTemplate() {
        return this.post('companies/mail-template/apply');
      },
      async publishMailTemplate() {
        return this.post('companies/mail-template/publish');
      },
      async unpublishMailTemplate() {
        return this.post('companies/mail-template/remove-from-publication');
      },
    },
  }
}
